// extracted by mini-css-extract-plugin
export default {"row":"StatsRow_row__nMxTs"};